(function (f, define) {
	define([], f);
})(function () {
	"use strict";

	const COLOR_SCHEME = "color-scheme";

	(function () {
		window.corrigoTheme = window.corrigoTheme || {};

		corrigoTheme.setup = function () {
			// Watch for changes in the system color scheme
			const updateColorScheme = () => {
				if (localStorage.getItem(COLOR_SCHEME) === "system") {
					var currentTheme = corrigoTheme.getPreferred();
					if (currentTheme === "no-preference") {
						currentTheme = "light";
					}
					document.documentElement.setAttribute("data-color-scheme", currentTheme);
				}
			};

			window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", updateColorScheme);
			window.matchMedia("(prefers-color-scheme: light)").addEventListener("change", updateColorScheme);
			window.matchMedia("(prefers-color-scheme: no-preference)").addEventListener("change", updateColorScheme);

			// setup current color scheme
			var theme = localStorage.getItem(COLOR_SCHEME) || 'light';
			if (theme === 'system') {
				theme = corrigoTheme.getPreferred();
				if (theme === "no-preference") {
					theme = "light";
				}
			}
			document.documentElement.setAttribute("data-color-scheme", theme);
		}

		corrigoTheme.get = function () {
			return localStorage.getItem(COLOR_SCHEME) || corrigoTheme.getPreferred();
		}

		corrigoTheme.set = function (theme) {
			localStorage.setItem(COLOR_SCHEME, theme || 'light');
			document.documentElement.setAttribute("data-color-scheme", theme);
		}

		corrigoTheme.getPreferred = function () {
			const darkQuery = "(prefers-color-scheme: dark)";
			const lightQuery = "(prefers-color-scheme: light)";
			const noPreferenceQuery = "(prefers-color-scheme: no-preference)";

			if (window.matchMedia) {
				if (window.matchMedia(darkQuery).matches) {
					return "dark";
				} else if (window.matchMedia(lightQuery).matches) {
					return "light";
				} else if (window.matchMedia(noPreferenceQuery).matches) {
					return "no-preference";
				}
			}
			return "light";
		}

	})();

	return window.corrigoTheme;

}, typeof define == 'function' && define.amd ? define : function (_, f) {
	f();
});
